import React from 'react';

import {brandRewardsCopy} from '../../../utils/rewards';

import OfferPanelLayout, {PanelButton} from './OfferPanelLayout';

type OfferSignInPanelProps = {
  onSignIn: () => void;
  onJoin: () => void;
};

const OfferSignInPanel = ({onSignIn, onJoin}: OfferSignInPanelProps) => {
  const program = brandRewardsCopy.loyaltyProgramName;
  return (
    <OfferPanelLayout
      testID="exclusive-offer-signin-panel"
      heading="Sign in to see your exclusive offer"
      body={`Your offer is linked to your ${program} account. Sign in to unlock it.`}>
      <PanelButton title="Sign in to view my offer" onPress={onSignIn} />
      <PanelButton title={`Not a member? Join ${program}`} onPress={onJoin} variant="text" />
    </OfferPanelLayout>
  );
};

export default OfferSignInPanel;
